import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { SimpleChipItem } from "@similarweb/ui-components";

export const Chip = styled(SimpleChipItem).attrs<{ $isActive?: boolean; strikethrough?: boolean }>((props) => ({
    $isActive: props.$isActive ?? false,
    strikethrough: props.strikethrough ?? false,
}))<{ $isActive?: boolean; strikethrough?: boolean }>`
    gap: 4px;
    margin: 0;

    [data-automation-icon-name="arrow"] {
        height: 5px;
        width: 10px;
        padding-right: 4px;
    }

    ${({ strikethrough }) =>
        strikethrough &&
        `
        text-decoration: line-through;
    `}

    ${({ $isActive }) =>
        $isActive &&
        `
        background-color: ${colorsPalettes.carbon[400]};

        .ChipItemText {
            color: ${colorsPalettes.carbon[0]};
        }
            
        svg path {
            fill: ${colorsPalettes.carbon[0]} !important;
        }

        &:hover {
            background-color: ${colorsPalettes.carbon[500]};
            cursor: pointer;
            ${setFontVariant("tooltip", colorsPalettes.carbon[400])};
        }
    `}
`;
